import React from "react";
import Skeleton from "react-loading-skeleton";
import "./UserAssessments.css";

const UserAssessmentsSkeleton = () => {
  return (
    <div style={{ padding: "20px" }}>
      {/* Heading */}
      <div style={{ marginBottom: "20px" }}>
        <Skeleton width={200} height={30} />
      </div>

      {/* Search Bar */}
      <div style={{ display: "flex", alignItems: "center", marginBottom: "30px" }}>
        <Skeleton circle width={20} height={20} style={{ marginRight: "10px" }} />
        <Skeleton width={200} height={25} />
      </div>

      {/* Assessment Cards in a grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
          gap: "20px",
        }}
      >
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <div
            key={i}
            style={{
              border: "1px solid #ddd",
              borderRadius: "12px",
              padding: "20px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              minHeight: "150px",
            }}
          >
            <div>
              <Skeleton width="70%" height={20} />
              <Skeleton count={2} height={15} style={{ marginTop: "8px" }} />
            </div>
            <div style={{ marginTop: "15px" }}>
              <Skeleton width={120} height={35} borderRadius={8} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UserAssessmentsSkeleton;